/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { motion } from 'framer-motion';
class IconBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isBookmarked: false,
    };
    this.handleBookmark = this.handleBookmark.bind(this);
  }

  handleBookmark() {
    this.setState({
      isBookmarked: !this.state.isBookmarked,
    });
  }

  render() {
    const { username } = this.props;
    let { isLiked } = this.props;
    const { isBookmarked } = this.state;
    return (
      <div className="icon-bar">
        <div className="icon-bar-items">
          <div className="left-icons">
            <button onClick={this.props.onLike} className="like">
              <motion.div
                animate={
                  isLiked ? { scale: [1, 1.29, 1] } : { scale: [1, 1.3, 1] }
                }
                transition={{ duration: 0.4 }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  width="24"
                  height="24"
                  viewBox="0 0 48 48"
                  fill={isLiked ? '#ED4956' : 'white'}
                  stroke={isLiked ? '#ED4956' : 'black'}
                  strokeWidth="5%"
                >
                  <path d="M 15 7 C 8.9424416 7 4 11.942442 4 18 C 4 22.096154 7.0876448 25.952899 10.851562 29.908203 C 14.615481 33.863507 19.248379 37.869472 22.939453 41.560547 A 1.50015 1.50015 0 0 0 25.060547 41.560547 C 28.751621 37.869472 33.384518 33.863507 37.148438 29.908203 C 40.912356 25.952899 44 22.096154 44 18 C 44 11.942442 39.057558 7 33 7 C 29.523564 7 26.496821 8.8664883 24 12.037109 C 21.503179 8.8664883 18.476436 7 15 7 z"></path>
                </svg>
              </motion.div>
            </button>
            <a href="#" className="full-post-link">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="24"
                height="24"
                viewBox="0 0 48 48"
                style={{ fill: '#000000' }}
              >
                <path d="M 24 4 C 12.972292 4 4 12.972292 4 24 C 4 27.275316 4.8627078 30.334853 6.2617188 33.064453 L 4.09375 40.828125 C 3.5887973 42.631528 5.3719261 44.41261 7.1757812 43.908203 L 14.943359 41.740234 C 17.671046 43.137358 20.726959 44 24 44 C 35.027708 44 44 35.027708 44 24 C 44 12.972292 35.027708 4 24 4 z M 24 7 C 33.406292 7 41 14.593708 41 24 C 41 33.406292 33.406292 41 24 41 C 20.997029 41 18.192258 40.218281 15.744141 38.853516 A 1.50015 1.50015 0 0 0 14.609375 38.71875 L 7.2226562 40.78125 L 9.2851562 33.398438 A 1.50015 1.50015 0 0 0 9.1503906 32.263672 C 7.7836522 29.813476 7 27.004518 7 24 C 7 14.593708 14.593708 7 24 7 z"></path>
              </svg>
            </a>
            <button className="share">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="24"
                height="24"
                viewBox="0 0 16 16"
                style={{ fill: '#000000' }}
              >
                <path
                  fill="white"
                  d="M0.912 5.919L15.174 0.826 10.081 15.088z"
                ></path>
                <path
                  fill="black"
                  d="M14.348,1.652L9.875,14.176L1.824,6.125L14.348,1.652 M16,0L0,5.714L10.286,16L16,0L16,0z"
                ></path>
                <g>
                  <path
                    fill="white"
                    d="M4.5 11.5L4.5 9.268 11.197 4.803 6.732 11.5z"
                  ></path>
                  <path
                    fill="black"
                    d="M9.394,6.606L6.465,11H5V9.535L9.394,6.606 M13,3L4,9v3h3L13,3L13,3z"
                  ></path>
                </g>
              </svg>
            </button>
          </div>
          <div className="right-icons">
            <button className="bookmark" onClick={this.handleBookmark}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="30"
                height="30"
                viewBox="0 0 30 30"
                stroke="black"
                fill={isBookmarked ? 'black' : 'white'}
                strokeWidth="5%"
              >
                {' '}
                <path d="M23,27l-8-7l-8,7V5c0-1.105,0.895-2,2-2h12c1.105,0,2,0.895,2,2V27z"></path>
              </svg>
            </button>
          </div>
        </div>
        <div className="like-message">
          {isLiked ? (
            <p>
              Liked by <a href="#">{username}</a>
            </p>
          ) : null}
        </div>
      </div>
    );
  }
}

export default IconBar;
